export default __webpack_public_path__ + "static/media/onboardingGraphicAppScreenshots.9bdf4ccf.svg";